<template>
<div class="chapter">
<div class="inner_page">
<section class="dedication" epub:type="dedication">
<p>For Liz. For everything.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?01a094ab